var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.relationsList),function(relation,idx){return _c('v-row',{key:idx,attrs:{"no-gutters":""}},[_c('the-relation',{attrs:{"relation":relation,"dataSourceName":_vm.dataSourceName,"featureId":_vm.featureId}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }